// Single source of truth for editorial content.

export const HERO = {
    firstName: "Manas",
    lastName: "Bhansali",
    lines: [
        "I enjoy solving problems where product thinking,",
        "engineering and AI come together.",
    ],
    sub: "Currently building AI products at OneCard.",
    resumeHref:
        "https://drive.google.com/drive/folders/1bF9qXMF6JNBelty-9IRwz8_c2GDZI0oD?usp=drive_link",
    location: "Pune · India",
};

export const MARQUEES = [
    {
        dur: 90,
        dir: "left",
        opacity: 1,
        weight: 500,
        items: [
            "Python",
            "JavaScript",
            "SQL",
            "C++",
            "Playwright",
            "n8n",
            "Langflow",
            "Langfuse",
            "Ollama",
            "GitHub",
            "DBMS",
            "Statistics",
        ],
    },
    {
        dur: 140,
        dir: "right",
        opacity: 0.6,
        weight: 400,
        items: [
            "Generative AI",
            "Prompt Engineering",
            "Conversational AI",
            "RAG",
            "Vector Embeddings",
            "YOLOv8",
            "OpenCV",
            "MediaPipe",
            "TensorFlow",
            "Scikit-Learn",
        ],
    },
    {
        dur: 110,
        dir: "left",
        opacity: 0.85,
        weight: 500,
        items: [
            "Product Strategy",
            "Roadmapping",
            "User Research",
            "PRDs",
            "Stakeholder Management",
            "KPI Tracking",
            "Product Lifecycle",
            "Cross-functional Collaboration",
            "Problem Solving",
            "Decision Making",
        ],
    },
];

export const EXPERIENCES = [
    {
        id: "onecard",
        company: "OneCard",
        subCompany: "FPL Technologies",
        role: "Product Manager",
        note: "Former Intern",
        duration: "Jan 2026 — Present",
        location: "Pune",
        bullets: [
            "Built and launched an AI Voice Collections platform from scratch, scaling it to 200K+ automated outbound calls per day in production.",
            "Owned strategy, prompt engineering, experimentation and cross-functional execution across engineering, data science and collections ops.",
            "Drove recovery of ₹260+ Cr from Post-Due-Date customers and ₹34+ Cr from NPA customers through AI-powered conversational workflows.",
        ],
        stack: [
            "Conversational AI",
            "Prompt Engineering",
            "PRDs",
            "Roadmapping",
            "KPI Tracking",
            "Langfuse",
        ],
    },
    {
        id: "bizamica",
        company: "Bizamica",
        subCompany: "Bizamica Software Pvt. Ltd.",
        role: "SDE & AI Intern",
        duration: "Jun 2025 — Sep 2025",
        location: "Pune",
        bullets: [
            "Built an AI-driven automation framework that converted 1000+ predefined test cases into executable Playwright scripts, reducing manual testing effort by 60%.",
            "Applied Generative AI to analyse 500+ Forex call recordings and extract structured insights, improving analysis turnaround time by 65%.",
            "Owned prototyping, evaluation and integration of the internal LLM tooling used across QA and finance workflows.",
        ],
        stack: [
            "Python",
            "Playwright",
            "Generative AI",
            "LLM Evaluation",
            "n8n",
        ],
    },
    {
        id: "infosys",
        company: "Infosys",
        subCompany: "Infosys Springboard",
        role: "Data Analyst Intern",
        duration: "Jan 2025 — Mar 2025",
        location: "Remote",
        bullets: [
            "Analysed 10K+ match records across cricket and badminton datasets to uncover player performance trends and impact metrics.",
            "Built interactive dashboards in Python and Tableau enabling comparative player analysis and cutting manual effort by 40%.",
            "Shipped an IPL 2025 Dream-Team predictor using historical data and ML techniques, achieving 78.2% prediction accuracy.",
        ],
        stack: [
            "Python",
            "Pandas",
            "Tableau",
            "Scikit-Learn",
            "Feature Engineering",
        ],
    },
    {
        id: "adiabatic",
        company: "Adiabatic",
        subCompany: "Adiabatic Technologies",
        role: "Hardware Intern",
        duration: "Mar 2024 — Aug 2024",
        location: "Remote",
        bullets: [
            "Engineered and tested a 32-cell Battery Management System for lithium-ion packs, enabling accurate per-cell voltage monitoring.",
            "Implemented over- and under-voltage protection to reduce cell-failure risk and improve safety under varying load.",
            "Contributed to circuit design and firmware integration across the BMS hardware stack.",
        ],
        stack: ["Embedded Systems", "Circuit Design", "KiCad", "Firmware"],
    },
];

export const PROJECTS = [
    {
        id: "proctorai",
        name: "ProctorAI",
        subtitle: "AI remote-proctoring in real time",
        year: "2026",
        summary:
            "A real-time proctoring pipeline for online exams. Face detection, identity verification, gaze tracking, head pose, phone and multi-person detection — all with sub-second alerts.",
        stack: [
            "YOLOv8",
            "MediaPipe",
            "OpenCV",
            "Flask",
            "React",
            "Computer Vision",
        ],
        demo: "#",
        github: "https://github.com/manasbhansali27/proctor-ai",
        art: "proctor",
    },
    {
        id: "chatrtx",
        name: "ChatRTX",
        subtitle: "Fully offline RAG over local files",
        year: "2025",
        summary:
            "An offline chatbot that answers questions across PDFs, docs, slides, images and video. FAISS vector search plus a local Ollama LLM, with a chunking pipeline that indexes 1000+ chunks.",
        stack: [
            "Ollama",
            "FAISS",
            "RAG",
            "Vector Embeddings",
            "Python",
            "NLP",
        ],
        demo: "https://drive.google.com/file/d/1ttFOSNmN5qNkT7Jfj8lSadrB3jca3Ni-/view?usp=sharing",
        github: "https://github.com/manasbhansali27/chat-with-files",
        art: "rtx",
    },
    {
        id: "smart-glasses",
        name: "Smart Glasses",
        subtitle: "Assistive scene understanding",
        year: "2025",
        summary:
            "AI-powered wearable that describes the world in audio. An ESP32 camera streams to a vision API pipeline; end-to-end latency tuned down to 12 seconds for a genuinely usable experience.",
        stack: [
            "ESP32",
            "Google Vision API",
            "Arduino",
            "Embedded",
            "IoT",
        ],
        demo: "#",
        github: null,
        art: "glasses",
    },
    {
        id: "charnet",
        name: "CharNet",
        subtitle: "Character recognition, built from scratch",
        year: "2025",
        summary:
            "A neural network written from first principles — no deep-learning framework. Two hidden layers assembled from raw NumPy, trained to classify all 94 printable English characters at 83.7% test accuracy, ~17% over a naive baseline.",
        stack: [
            "Python",
            "NumPy",
            "Neural Networks",
            "Backpropagation",
        ],
        demo: null,
        github:
            "https://github.com/manasbhansali27/character-recognition-neural-network",
        art: "neuralnet",
    },
    {
        id: "notesense",
        name: "NoteSense",
        subtitle: "Currency detection with audio feedback",
        year: "2024",
        summary:
            "A real-time system that spots Indian currency notes through a webcam and announces the denomination aloud in Hindi and English. 94.2% detection accuracy at a ~2s response time — built to genuinely help visually-impaired users.",
        stack: ["Python", "YOLOv8", "OpenCV", "Pygame"],
        demo: "#",
        github: "https://github.com/manasbhansali27",
        art: "currency",
    },
    {
        id: "aircursor",
        name: "AirCursor",
        subtitle: "Control your cursor with hand gestures",
        year: "2024",
        summary:
            "Your webcam becomes a trackpad. Real-time hand tracking maps finger gestures to cursor movement, clicks and scrolling — no extra hardware, just Python. Built on MediaPipe landmarks with PyAutoGUI for smooth, low-latency control.",
        stack: ["Python", "OpenCV", "MediaPipe", "PyAutoGUI"],
        demo: "#",
        github: "https://github.com/manasbhansali27/gesture-controlled-mouse",
        art: "gesture",
    },
];

export const EDUCATION = [
    {
        id: "pict",
        school: "Pune Institute of Computer Technology",
        degree: "B.E. Electronics & Telecommunication",
        detail: "Honors in Artificial Intelligence & Machine Learning",
        period: "2022 — 2026",
        location: "Pune, Maharashtra",
        result: "CGPA 8.73",
    },
    {
        id: "narayana",
        school: "Narayana Junior College",
        degree: "HSC — Higher Secondary (Science)",
        detail: "Telangana State Board (TSBIE)",
        period: "2020 — 2022",
        location: "Hyderabad, Telangana",
        result: "97.73%",
    },
];

export const CONTACT = {
    email: "mmbhansali027@gmail.com",
    phone: "+91 70759 53323",
    linkedin: "https://www.linkedin.com/in/manasbhansali/",
    github: "https://github.com/manasbhansali27",
    leetcode: "https://leetcode.com/manasbhansali",
};

export const CHAPTERS = [
    { n: "01", label: "Prologue", target: "hero" },
    { n: "02", label: "Vocabulary", target: "marquee" },
    { n: "03", label: "Work", target: "work" },
    { n: "04", label: "Projects", target: "projects" },
    { n: "05", label: "Contact", target: "contact" },
];
